// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__RWESR","title":"Info_title__2JU1f","selects":"Info_selects__38O9b","requiredAsterisk":"Info_requiredAsterisk__3yGqr"};